import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { PaymentSessionForm } from '@components/Payment/PaymentSessionForm';
import { t } from '@lingui/core/macro';
import { useParams } from 'react-router-dom';

export const TireOfferConfirmationWithPaymentLeft = () => {
  const { sessionId } = useParams() as { sessionId: string };

  return (
    <ContentWrapperCustomerApp title={t`How would you like to pay?`} hideBackButton>
      <PaymentSessionForm sessionId={sessionId} countryCode='NO' />
    </ContentWrapperCustomerApp>
  );
};
